/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationDefs from '../moderation/defs.defs.js'

const $nsid = 'tools.ozone.verification.defs'

type $nsid = typeof $nsid

export { $nsid }

/** Verification data for the associated subject. */
type VerificationView = {
  $type?: 'tools.ozone.verification.defs#verificationView'

  /**
   * The user who issued this verification.
   */
  issuer: l.DidString

  /**
   * The AT-URI of the verification record.
   */
  uri: l.AtUriString

  /**
   * The subject of the verification.
   */
  subject: l.DidString

  /**
   * Handle of the subject the verification applies to at the moment of verifying, which might not be the same at the time of viewing. The verification is only valid if the current handle matches the one at the time of verifying.
   */
  handle: l.HandleString

  /**
   * Display name of the subject the verification applies to at the moment of verifying, which might not be the same at the time of viewing. The verification is only valid if the current displayName matches the one at the time of verifying.
   */
  displayName: string

  /**
   * Timestamp when the verification was created.
   */
  createdAt: l.DatetimeString

  /**
   * Describes the reason for revocation, also indicating that the verification is no longer valid.
   */
  revokeReason?: string

  /**
   * Timestamp when the verification was revoked.
   */
  revokedAt?: l.DatetimeString

  /**
   * The user who revoked this verification.
   */
  revokedBy?: l.DidString
  subjectProfile?: l.Unknown$TypedObject
  issuerProfile?: l.Unknown$TypedObject
  subjectRepo?:
    | l.$Typed<ModerationDefs.RepoViewDetail>
    | l.$Typed<ModerationDefs.RepoViewNotFound>
    | l.Unknown$TypedObject
  issuerRepo?:
    | l.$Typed<ModerationDefs.RepoViewDetail>
    | l.$Typed<ModerationDefs.RepoViewNotFound>
    | l.Unknown$TypedObject
}

export type { VerificationView }

/** Verification data for the associated subject. */
const verificationView = /*#__PURE__*/ l.typedObject<VerificationView>(
  $nsid,
  'verificationView',
  /*#__PURE__*/ l.object({
    issuer: /*#__PURE__*/ l.string({ format: 'did' }),
    uri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    subject: /*#__PURE__*/ l.string({ format: 'did' }),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    displayName: /*#__PURE__*/ l.string(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    revokeReason: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    revokedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    revokedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'did' }),
    ),
    subjectProfile: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion([], false),
    ),
    issuerProfile: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion([], false),
    ),
    subjectRepo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<ModerationDefs.RepoViewDetail>(
            (() => ModerationDefs.repoViewDetail) as any,
          ),
          /*#__PURE__*/ l.typedRef<ModerationDefs.RepoViewNotFound>(
            (() => ModerationDefs.repoViewNotFound) as any,
          ),
        ],
        false,
      ),
    ),
    issuerRepo: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<ModerationDefs.RepoViewDetail>(
            (() => ModerationDefs.repoViewDetail) as any,
          ),
          /*#__PURE__*/ l.typedRef<ModerationDefs.RepoViewNotFound>(
            (() => ModerationDefs.repoViewNotFound) as any,
          ),
        ],
        false,
      ),
    ),
  }),
)

export { verificationView }
